__turbopack_context__.v({
  "btn-center": "ButtonBlock-module__7Kriqa__btn-center",
  "btn-col--center": "ButtonBlock-module__7Kriqa__btn-col--center",
  "btn-col--left": "ButtonBlock-module__7Kriqa__btn-col--left",
  "btn-col--right": "ButtonBlock-module__7Kriqa__btn-col--right",
  "btn-right": "ButtonBlock-module__7Kriqa__btn-right",
  "buttonBlock": "ButtonBlock-module__7Kriqa__buttonBlock",
});
